<template>
  <v-card class="d-flex flex-column h-100">
    <ModuleSelectTitle
      v-if="cycle.modules.length"
      :progress="cycle.content_progress"
      title="Módulos"
      class="border-bottom"
    />
    <v-container
      :fluid="true"
      class="my-3"
    >
      <v-row>
        <v-col
          v-for="module in modules"
          :key="module.name"
          cols="12"
          md="4"
        >
          <v-badge
            bordered
            color="theme"
            :content="module.count_uncompleted_contents"
            :value="module.completed && (current_cycle && current_cycle.id == cycle.id) && module.count_uncompleted_contents > 0"
            overlap
            class="w-100"
          >
            <ContentCard
              theme="module"
              class="d-flex justify-content-between flex-column"
              :status="getStatus(module, cycle)"
            >
              <ModuleInnerContentCard
                :module="module"
                :cycle="cycle"
              />
            </ContentCard>
            <div class="pt-1 pt-md-0 d-flex justify-content-between mb-1">
              <div class="d-flex align-items-center">
                <p class="font-weight-bold smaller-text">
                  Progresso na meta
                </p>
                <BtnInfo tooltip-text="% de progresso dentro do período definido pela escola" />
              </div>
              <p class="smaller-text">
                {{ Math.round(module.goal_progress) }}%
              </p>
            </div>
            <v-progress-linear
              color="nitro"
              height="10"
              rounded
              class="rounded-pill"
              :value="Math.ceil(module.goal_progress)"
            />
          
            <v-progress-linear
              color="purple"
              height="10"
              rounded
              class="rounded-pill mt-3"
              :value="Math.ceil(module.module_progress)"
            />
            <div class="pt-1 pt-md-0 d-flex justify-content-between smaller-text mt-1">
              <div class="d-flex align-items-center">
                <p class="font-weight-bold smaller-text">
                  Progresso geral
                </p>
                <BtnInfo tooltip-text="% de progresso em qualquer período" />
              </div>
              <p class="smaller-text">
                {{ Math.round(module.module_progress) }}%
              </p>
            </div>
          </v-badge>
        </v-col>
        <v-col v-if="modulesSelectionIsPending">
          <ChooseModulesWarning :cycle="cycle" />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import ModuleInnerContentCard from './content/ModuleInnerContentCard'
import ModuleSelectTitle from '../ModuleSelectTitle'
import ContentCard from "@/common/components/ContentCard";
import ChooseModulesWarning from '@/student/pages/cycle/components/ChooseModulesWarning'
import BtnInfo from '@/common/components/BtnInfo';

export default {
  components: {
    ModuleSelectTitle,
    ContentCard,
    ChooseModulesWarning,
    ModuleInnerContentCard,
    BtnInfo
  },
  props: {
    cycle: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(["current_cycle"]),
    modules(){
      return this.cycle.modules;
    },
    modulesSelectionIsPending(){
      return this.cycle.released || this.cycle.should_select_modules;
    }
  },
  methods: {
    getStatus(module, cycle){
      if(cycle.cant_start_module || this.$moment(module.begin_date).isAfter())
        return 'disabled'
      if((module.completed || module.count_completed_contents >= module.count_contents) && module.count_contents > 0)
        return 'completed'
      else
        return 'not-completed'
    }
  }
}
</script>

<style scoped>
  .smaller-text {
    margin: 0;
    font-size: 1rem;
  }
</style>